import { Component } from 'react';
// @ts-expect-error untyped JS module
import formatName from '../utils/formatName';
// @ts-expect-error untyped JS module
import formatFriendlyName from '../utils/formatFriendlyName';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
export default class FormattedName extends Component {
  render() {
    const {
      email,
      familyName,
      givenName,
      isFriendly,
      name,
      options,
      titleType
    } = this.props;
    const formattedName = isFriendly ? formatFriendlyName({
      givenName,
      familyName,
      email
    }, options) : formatName({
      firstName: givenName,
      lastName: familyName,
      email,
      name,
      titleType
    }, options);
    return /*#__PURE__*/_jsx("span", {
      children: formattedName
    });
  }
}
FormattedName.displayName = 'FormattedName';
FormattedName.contextType = I18nHMRContext;
FormattedName.defaultProps = {
  isFriendly: false
};